import { getErrorMessage } from '@/core/lib/utils/get-error-message'
import { IHttpClient } from '@/core/services/http'
import { AxiosError } from 'axios'
import { Category } from '../model/category.model'
import { LANGUAGE_HEADER } from '@/core/constants/http-headers'
import { getLocale } from 'next-intl/server'

export function createGetCategoriesUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (): Promise<Category[]> {
    const local = await getLocale()
    try {
      const res = await httpClient
        .version('v1')
        .addHeaders(LANGUAGE_HEADER(local))
        .get<{ data: Category[] }>(`/website/buyer/categories?parents=1`)
      return res.data.data
    } catch (err) {
      console.log(
        `🚨 Failed to get categories`,
        getErrorMessage(err),
        err instanceof AxiosError ? err.status : '',
      )
      return []
    }
  }
}
